module.exports = __webpack_public_path__ + "img/UD.e0b73044.png";